var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 6.16732H7.83331V1.16732C7.83331 0.946304 7.74552 0.734343 7.58924 0.578062C7.43296 0.421782 7.22099 0.333984 6.99998 0.333984C6.77897 0.333984 6.567 0.421782 6.41072 0.578062C6.25444 0.734343 6.16665 0.946304 6.16665 1.16732V6.16732H1.16665C0.945633 6.16732 0.733671 6.25512 0.577391 6.4114C0.421111 6.56768 0.333313 6.77964 0.333313 7.00065C0.333313 7.22166 0.421111 7.43363 0.577391 7.58991C0.733671 7.74619 0.945633 7.83398 1.16665 7.83398H6.16665V12.834C6.16665 13.055 6.25444 13.267 6.41072 13.4232C6.567 13.5795 6.77897 13.6673 6.99998 13.6673C7.22099 13.6673 7.43296 13.5795 7.58924 13.4232C7.74552 13.267 7.83331 13.055 7.83331 12.834V7.83398H12.8333C13.0543 7.83398 13.2663 7.74619 13.4226 7.58991C13.5788 7.43363 13.6666 7.22166 13.6666 7.00065C13.6666 6.77964 13.5788 6.56768 13.4226 6.4114C13.2663 6.25512 13.0543 6.16732 12.8333 6.16732Z",
    fill: "#354ACD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plusIcon.5b0f8809d56037ad129c4d18aa758eb5.svg";